import { useTranslation } from 'react-i18next'
import { getStatusColor } from 'src/utils'
import './Status.css'

interface BaseStatusProps {
    cellColorMap: any
    className?: string
}

type StatusProps =
    | (BaseStatusProps & {
        cellContent: string
        children?: never
    })
    | (BaseStatusProps & {
        children: React.ReactNode
        cellContent?: never
    })

const Status = ({ cellContent, cellColorMap, children, className }: StatusProps) => {
    const { t } = useTranslation()

    const content = cellContent ?? ''

    const colors = cellContent
        ? getStatusColor(cellContent, cellColorMap)
        : undefined

    return (
        <div
            className={`status-container ${className ?? ''}`}
            style={{
                backgroundColor: colors?.bg,
                color: colors?.text,
            }}
        >
            <span>

                {children ?? t(content)}
            </span>
        </div>
    )
}

export default Status
